import React from 'react';

const CustomDivider = () => {
	return (
		<hr style={{
			border: '8px solid #D6DC32',
			borderRadius: '12px',
			marginTop: '16px',
			marginBottom: '16px'
		}} />
	);
};

export { CustomDivider };